module.exports = __webpack_public_path__ + "pnskfsquadron/img/m-book-hero1.png?2bdb9acc";